import { render, staticRenderFns } from "./manufacturerAction.vue?vue&type=template&id=72d09fb8&scoped=true"
import script from "./manufacturerAction.vue?vue&type=script&lang=js"
export * from "./manufacturerAction.vue?vue&type=script&lang=js"
import style0 from "./manufacturerAction.vue?vue&type=style&index=0&id=72d09fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d09fb8",
  null
  
)

export default component.exports